import React, { useState } from 'react';
import { Button } from '../../ui/button';
import { Bank, CreditCard, Certificate } from '@phosphor-icons/react';
import { digitalPayment, digitalCertificate, digitalError, saveBlob } from '../../../services/api/digitalAdhesion';

export const DigitalPayment = ({ token, kit, onChanged }) => {
  const [busy, setBusy] = useState(false); const [error, setError] = useState('');
  const [bank, setBank] = useState(kit.status === 'pending_transfer' ? { bank: kit.bank, reference: (kit.bank?.reference_pattern || '').replace('{nom}', kit.beneficiary?.name || '') } : null);
  const pay = async (method) => {
    setBusy(true); setError('');
    try {
      const r = await digitalPayment(token, method);
      if (method === 'stripe') {
        if (!r.data.checkout_url) throw new Error('Lien de paiement absent');
        window.location.assign(r.data.checkout_url);
      } else { setBank(r.data); await onChanged(); }
    }
    catch (e) { setError(await digitalError(e)); } finally { setBusy(false); }
  };
  const certificate = async () => { setBusy(true); setError(''); try { const r = await digitalCertificate(token); saveBlob(r.data, 'certificat-associe.pdf'); } catch (e) { setError(await digitalError(e)); } finally { setBusy(false); } };
  return <section className="border-t border-[#E8E6E1] pt-6 space-y-4" data-testid="digital-payment">
    <h2 className="text-lg font-semibold">{kit.status === 'paid' ? 'Inscription finalisée' : 'Libération des parts sociales'}</h2>
    {kit.status === 'paid' ? <>
      <p data-testid="digital-associate-number">Numéro d’associé : <strong>{kit.associate_number}</strong></p>
      <Button onClick={certificate} disabled={busy} data-testid="digital-certificate"><Certificate size={18} className="mr-2" />Certificat d’associé</Button>
    </> : <>
      <p data-testid="digital-payment-amount">Montant à libérer : <strong>{Number(kit.amount).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' })}</strong></p>
      <div className="flex flex-wrap gap-2">
        <Button disabled={busy} onClick={() => pay('stripe')} className="bg-[#2D5A4C] hover:bg-[#1E4136]" data-testid="digital-pay-card"><CreditCard size={18} className="mr-2" />Payer par carte</Button>
        <Button variant="outline" disabled={busy} onClick={() => pay('bank')} data-testid="digital-pay-bank"><Bank size={18} className="mr-2" />Virement bancaire</Button>
      </div>
      {bank && <div className="text-sm space-y-2 border-l-4 border-[#8DB0A1] pl-4 break-words" data-testid="digital-bank-details">
        <p>{bank.bank?.titulaire}</p><p data-testid="digital-bank-iban">IBAN : {bank.bank?.iban}</p><p>BIC : {bank.bank?.bic}</p>
        <p data-testid="digital-bank-reference">Référence : {bank.reference}</p>
        <p>La coopérative confirmera la réception du paiement avant d’inscrire l’associé au registre et de délivrer le certificat.</p>
      </div>}
    </>}
    {error && <p role="alert" className="text-red-700 text-sm" data-testid="digital-payment-error">{error}</p>}
  </section>;
};